import { Dialog } from 'antd-mobile'
import { DownloadOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react'
import { commonUtils } from '@/helpers/commonUtils'
import styles from './DownloadProgressPopup.module.less'
import { uiController } from '@/controllers/uiController'
import { userService } from '@/services/userService/userService'
import { useWechatBiluLaunchInfo } from '@/components/mobile/useWechatBiluLaunchInfo'

export interface DownloadProgressPopupProps {
  visible: boolean
  onClose: () => void
}

const DownloadProgressPopupContent = observer((props: DownloadProgressPopupProps) => {
  const isWechat = commonUtils.isWechat()
  const { canUseWechatLaunch, launchInfo, refreshLaunchInfo } = useWechatBiluLaunchInfo(
    props.visible,
    userService.isLogin,
    'download'
  )
  const launchTemplate = `<template><img src="${commonUtils.getStaticFile(
    'pc/bilu.jpg'
  )}" alt="ai-preview" style="display:block;width:100%;height:auto;" /></template>`

  return (
    <div className={styles.downloadProgressPopup}>
      <div className={styles.headerCard}>
        <div className={styles.downloadIcon}>
          <DownloadOutlined />
        </div>
        <div className={styles.headerText}>
          <div className={styles.title}>课件正在下载中</div>
          <div className={styles.description}>
            请前往浏览器【下载列表】
            <br />
            查看当前下载进度
          </div>
          <div className={styles.tip}>下载时间会根据文件大小有所不同，请耐心等待</div>
        </div>
      </div>

      <div className={styles.divider}>等待下载期间，为您推荐</div>

      <div className={styles.aiCard}>
        <div
          className={styles.aiPreview}
          onMouseDownCapture={() => {
            if (isWechat && userService.isLogin) {
              void refreshLaunchInfo()
            }
          }}
          onTouchStartCapture={() => {
            if (isWechat && userService.isLogin) {
              void refreshLaunchInfo()
            }
          }}
          onClick={
            canUseWechatLaunch
              ? undefined
              : () => {
                  uiController.navigateTBilu('download', '移动端详情页面下载弹窗')
                }
          }
        >
          <img src={commonUtils.getStaticFile('pc/bilu.jpg')} alt='ai-preview' />
          {canUseWechatLaunch && (
            <wx-open-launch-weapp
              id='download-popup-launch-btn'
              username={launchInfo!.username}
              path={launchInfo!.path}
              class={styles.aiPreviewLaunch}
              dangerouslySetInnerHTML={{ __html: launchTemplate }}
            />
          )}
        </div>
      </div>

      <div className={styles.footerActions}>
        <button type='button' className={styles.confirmButton} onClick={props.onClose}>
          我知道了,继续查看课件
        </button>
      </div>
    </div>
  )
})

const DownloadProgressPopup = observer((props: DownloadProgressPopupProps) => {
  return (
    <Dialog
      style={
        {
          '--max-width': '100vw',
        } as React.CSSProperties
      }
      visible={props.visible}
      onClose={props.onClose}
      closeOnMaskClick
      bodyStyle={{
        padding: 0,
        backgroundColor: 'transparent',
      }}
      content={<DownloadProgressPopupContent {...props} />}
      getContainer={() => document.body}
    />
  )
})

export default DownloadProgressPopup
